import { render, staticRenderFns } from "./newsListProgress.vue?vue&type=template&id=73fa5252&scoped=true&"
import script from "./newsListProgress.vue?vue&type=script&lang=js&"
export * from "./newsListProgress.vue?vue&type=script&lang=js&"
import style0 from "./newsListProgress.vue?vue&type=style&index=0&id=73fa5252&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa5252",
  null
  
)

export default component.exports